<vc-spinner *ngIf="userReview == null || !allSectionsLoaded"></vc-spinner>

<div
   *ngIf="userReview != null"
   class="outer-container">
   <div
      *ngIf="allSectionsLoaded && reviewPlan.revieweeUserStatus == 'TERMINATED'"
      class="cycle-closed-notice"
      style="width: 100%">
      <i class="fa fa-lock cycle-closed-notice__icon"></i>
      <div class="cycle-closed-notice__body">
         <span class="cycle-closed-notice__title">This user is TERMINATED</span>
      </div>
   </div>

   <div
      *ngIf="allSectionsLoaded && (isUserDeferred() || !isReviewTypeEnabled)"
      class="cycle-closed-notice"
      style="width: 100%">
      <i class="fa fa-lock cycle-closed-notice__icon"></i>
      <div class="cycle-closed-notice__body">
         <span class="cycle-closed-notice__title">
            {{ isUserDeferred() ? "This review has been deferred." : "The cycle for this review has closed." }}
         </span>
         <span class="cycle-closed-notice__reason"></span>
      </div>
   </div>

   <!-- For admin use only -->
   <vc-rounded-card
      *ngIf="allSectionsLoaded && performanceHubAdmin.includes(+loggedInUserId)"
      class="admin-only">
      <div style="width: 100%">
         <div class="align-items-center admin-inner-block">
            <div class="admin-only-column">
               <div style="display: flex; flex-direction: row; gap: 20px">
                  <span
                     class="admin-only-header"
                     style="margin-right: auto">
                     <i
                        class="fa fa-lock"
                        style="color: #ba7517"></i>
                     &nbsp;FOR ADMIN USE ONLY
                     <br />
                     <div class="admin-directions">Override and save either side of this review, bypassing all validation checks.</div>
                  </span>
                  <button
                     (click)="submittedByAdminClicked = true; onClickSave(true, false)"
                     class="v-button v-button-md v-blue"
                     style="align-self: start; margin-top: 15px">
                     <i class="fa fa-lock"></i>
                     &nbsp;Override & Save Self-Assessment
                  </button>

                  <!--<button
                     (click)="submittedByAdminReviewerClicked = true; submittedByAdminReviewer = true; onClickSave(true, false)"
                     class="v-button v-button-md v-blue"
                     style="align-self: start; margin-top: 15px">
                     <i class="fa fa-lock"></i>
                     &nbsp;Override & Save {{ getReviewerLabel(true) }} Review
                  </button>-->
               </div>
               <span style="margin-top: 2px">
                  <a
                     href="javascript:void(0);"
                     class="admin-only-header"
                     style="font-size: 11px; letter-spacing: 1px; display: flex; gap: 5px; align-items: center"
                     (click)="adminOnlyAttachmentExpanded = !adminOnlyAttachmentExpanded">
                     <i
                        style="font-size: 11px; align-self: baseline; padding-top: 2px"
                        class="fa fa-caret-down"
                        [style.rotate]="!adminOnlyAttachmentExpanded ? '-90deg' : ''"
                        [style.margin-top]="adminOnlyAttachmentExpanded ? '1px' : ''"
                        [style.margin-left]="adminOnlyAttachmentExpanded ? '2px' : ''"
                        [style.margin-right]="adminOnlyAttachmentExpanded ? '-2px' : ''"></i>
                     &nbsp;ADVANCED
                  </a>

                  <div
                     *ngIf="adminOnlyAttachmentExpanded"
                     style="font-weight: 600; font-size: 13px; margin-top: 8px; display: flex; flex-direction: row; justify-content: space-between">
                     <span>Upload a Written Review or an Additional Document</span>
                     <span>Reset This Review</span>
                  </div>

                  <div
                     *ngIf="adminOnlyAttachmentExpanded"
                     style="margin-top: 2px; display: flex; flex-direction: row; gap: 20px">
                     <div class="upload-box">
                        <i class="fa fa-cloud-upload"></i>
                        <br />
                        <div class="dragText">Drag and drop your PDF or Browse</div>

                        <div class="fileSelector">
                           <input
                              #attachmentInput
                              type="file"
                              accept="application/pdf,.pdf"
                              (change)="onAttachmentSelected($event)" />
                        </div>
                     </div>

                     <div
                        style="border-right: 1px solid #ebe5d4"
                        [style.margin-right]="reviewAttachments.length > 0 ? '' : 'auto'"></div>

                     <div
                        *ngIf="reviewAttachments.length > 0"
                        style="margin-right: auto">
                        <span
                           class="admin-only-header"
                           style="font-size: 11px">
                           CURRENT ATTACHMENT
                        </span>
                        <div class="admin-attachment-list">
                           <span
                              class="admin-attachment-chip"
                              *ngFor="let a of reviewAttachments"
                              (click)="openAttachment(a)"
                              title="Uploaded by {{ a.uploadedByName }}">
                              <i class="fa fa-file-pdf"></i>
                              <span style="font-weight: 600">
                                 {{ a.fileName }}
                                 <br />
                                 <span style="font-size: 11px; color: #686868">
                                    Uploaded on {{ formatUploadedOn(a.uploadedOn) }} by {{ a.uploadedByName }}
                                 </span>
                              </span>
                              <i
                                 class="fa fa-eye admin-attachment-remove"
                                 title="Open attachment"
                                 (click)="openAttachment(a)"></i>
                              <i
                                 class="fa fa-download admin-attachment-remove"
                                 title="Download attachment"
                                 (click)="downloadAttachment(a, $event)"></i>
                              <i
                                 class="fa fa-times admin-attachment-remove"
                                 style="font-size: 15px"
                                 title="Remove attachment"
                                 (click)="deleteAttachment(a, $event)"></i>
                           </span>
                        </div>
                     </div>
                     <div
                        *ngIf="adminOnlyAttachmentExpanded"
                        class="admin-reset">
                        <span>Erases answers on either or both sides.</span>
                        <button
                           (click)="resetReviewee(userReview.id)"
                           class="v-button v-button-sm v-red"
                           style="background: #b91610; border-color: #b91610">
                           <i class="fa fa-trash"></i>
                           &nbsp;Reset Reviewee
                        </button>
                        <button
                           (click)="resetReviewer(userReview.id)"
                           class="v-button v-button-sm v-red"
                           style="background: #b91610; border-color: #b91610">
                           <i class="fa fa-trash"></i>
                           &nbsp;Reset Reviewer
                        </button>
                        <button
                           (click)="resetReview(userReview.id)"
                           class="v-button v-button-sm v-red"
                           style="background: #b91610; border-color: #b91610">
                           <i class="fa fa-trash"></i>
                           &nbsp;Reset Both Reviewee & Reviewer
                        </button>
                     </div>
                  </div>
               </span>
            </div>
         </div>
      </div>
   </vc-rounded-card>

   <div
      *ngIf="allSectionsLoaded && !reviewTypeSet"
      class="outer-container">
      <div class="grid-container top-info">
         <vc-rounded-card
            class="namesCard"
            titleSize="large"
            style="flex: 1; position: relative">
            <div style="color: #494848; text-align: center">
               <i
                  class="fa fa-circle-exclamation"
                  style="color: #ed5a68"></i>
               &nbsp;The review type for this user has not been set
            </div>
         </vc-rounded-card>
      </div>
   </div>

   <div
      *ngIf="allSectionsLoaded && reviewTypeSet"
      class="outer-container">
      <div class="grid-container top-info">
         <vc-rounded-card
            class="namesCard"
            titleSize="large"
            style="flex: 0.7; position: relative">
            <div class="d-flex flex-row flex-nowrap justify-content-between mt-0 mb-0 gap-3 assess-card">
               <div class="mainHeader">
                  {{ isReviewer ? "Performance Review for" : "Self-Assessment for" }}
                  <span style="color: #818181">{{ userReview.revieweeName }}</span>
               </div>
               <button
                  class="v-button v-button-lg v-darkgreen printButton"
                  (click)="openPrintChoiceModal()"
                  *ngIf="isReviewer ? true : isDVMSubmitted && isCOSSubmitted ? true : false">
                  <i class="fa fa-print"></i>
                  &nbsp;Print Review
               </button>
            </div>

            <div
               *ngIf="isDVMSubmitted && isCOSSubmitted"
               style="height: 1px">
               &nbsp;
            </div>

            <div class="d-flex flex-row flex-nowrap mt-0 mb-0 gap-3 assess-card">
               <div
                  class="name-container"
                  style="flex: 1">
                  <div class="info-grid">
                     <div class="info-item">
                        <div
                           class="item-heading"
                           [class.is-user-label]="!isReviewer">
                           {{ getRevieweeLabel() }}
                        </div>
                        <div
                           [class.is-user]="!isReviewer"
                           class="item-value">
                           {{ userReview.revieweeName }}
                        </div>
                     </div>

                     <div class="info-item">
                        <div class="item-heading">DATE HIRED</div>
                        <div class="item-value">{{ userReview.dateHired | date }}</div>
                     </div>

                     <div
                        *ngIf="reviewType != 'DO'"
                        class="info-item">
                        <div class="item-heading">HOSPITAL</div>
                        <div class="item-value">{{ userReview.practiceName ? userReview.practiceName : "---" }}</div>
                     </div>

                     <div class="info-item">
                        <div
                           class="item-heading"
                           [class.is-user-label]="getReviewerName(userReview) && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           {{ getReviewerLabel() }}
                        </div>
                        <div
                           class="item-value"
                           [class.is-user]="getReviewerName(userReview) && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           {{ getReviewerName(userReview) ? getReviewerName(userReview) : "---" }}
                           {{
                              reviewType == "DVM" &&
                              isCOS &&
                              (loggedInUser == reviewPlan.cosDisplayName || loggedInUserId == +reviewPlan.cosUserId) &&
                              loggedInUser != getReviewerName(userReview)
                                 ? " / " + loggedInUser
                                 : ""
                           }}
                        </div>
                        <span
                           *ngIf="
                              (reviewType === 'COS' ? newCOSA : getNewReviewerValue()) &&
                              (reviewType === 'COS' ? newCOSA : getNewReviewerValue()) !== getReviewerName(userReview)
                           "
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ reviewType === "COS" ? newCOSA : getNewReviewerValue() }}
                        </span>
						
						<span
   *ngIf="
      userReview.hmName2 &&
      userReview.hmName != userReview.hmName2 &&
      newHM != userReview.hmName2 &&
      (reviewType == 'CROSSTRAINED' || reviewType == 'CLINICAL' || reviewType == 'RECEPTION')
   "
   style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
   <i
      class="fa fa-arrow-turn-up"
      style="transform: rotate(90deg)"></i>
   &nbsp;Other: {{ userReview.hmName2 }}
</span>
                     </div>

                     <div
                        *ngIf="reviewType == 'DVM' || reviewType == 'HM'"
                        class="info-item">
                        <div
                           class="item-heading"
                           [class.is-user-label]="userReview.vetLeaderName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           CHIEF OF STAFF ADVISOR
                        </div>
                        <div
                           class="item-value"
                           [class.is-user]="userReview.vetLeaderName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           {{ userReview.vetLeaderName }}
                        </div>
                        <span
                           *ngIf="newCOSA && newCOSA != userReview.vetLeaderName"
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ newCOSA }}
                        </span>
                     </div>

                     <div
                        *ngIf="reviewType == 'CROSSTRAINED' || reviewType == 'CLINICAL' || reviewType == 'RECEPTION'"
                        class="info-item">
                        <div
                           class="item-heading"
                           [class.is-user-label]="userReview.cosName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           CHIEF OF STAFF
                        </div>
                        <div
                           class="item-value"
                           [class.is-user]="userReview.cosName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           {{ userReview.cosName ? userReview.cosName : "---" }}
                        </div>
                        <span
                           *ngIf="newCOS && newCOS != userReview.cosName"
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ newCOS }}
                        </span>
                     </div>

                     <div
                        *ngIf="
                           reviewType == 'DVM' ||
                           reviewType == 'COS' ||
                           reviewType == 'CROSSTRAINED' ||
                           reviewType == 'CLINICAL' ||
                           reviewType == 'RECEPTION'
                        "
                        class="info-item">
                        <div
                           class="item-heading"
                           [class.is-user-label]="userReview.rmName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           REGIONAL MANAGER
                        </div>
                        <div
                           class="item-value"
                           [class.is-user]="userReview.rmName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           {{ userReview.rmName }}
                        </div>
                        <span
                           *ngIf="newRM && newRM != userReview.rmName"
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ newRM }}
                        </span>
                     </div>

                     <div
                        *ngIf="reviewType == 'COS'"
                        class="info-item">
                        <div
                           class="item-heading"
                           [class.is-user-label]="userReview.directorName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           DIRECTOR OF OPERATIONS
                        </div>
                        <div
                           class="item-value"
                           [class.is-user]="userReview.directorName && isPrimaryReviewer && shouldShowReviewerQuestions()">
                           {{ userReview.directorName }}
                        </div>
                        <span
                           *ngIf="newDO && newDO != userReview.directorName"
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ newDO }}
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </vc-rounded-card>

         <vc-rounded-card
            colorClass="v-blue"
            class="versionsCard"
            style="flex: 0.3">
            <div
               *ngIf="userReview != null"
               class="date-container">
               <div class="vc-header">
                  <h3
                     class="vc-title"
                     style="flex: 0.6">
                     <i
                        class="vc-icon"
                        aria-hidden="true"></i>
                     Status Updates
                  </h3>
                  <div
                     class="vc-meta"
                     style="flex: 0.4">
                     <div class="meta-heading light-text">
                        {{ userReview.dateUpdated ? "Last Refreshed" : "Review has not yet been submitted" }}
                     </div>
                     <div class="meta-value light-text">
                        {{ userReview.dateUpdated ? getLastSavedDatetime() : "" }}
                     </div>
                  </div>
               </div>

               <hr />

               <div class="mt-4">
                  <div style="display: flex; flex-direction: column; gap: 10px">
                     <!-- Show submission dates -->
                     <div
                        *ngIf="isDVMSubmitted || isCOSSubmitted"
                        class="submission-dates"
                        style="margin-bottom: 10px">
                        <div
                           class="submitted-info"
                           style="margin-bottom: 5px">
                           @if (submittedByAdmin) {
                              <span
                                 *ngIf="isDVMSubmitted"
                                 style="text-decoration: line-through; opacity: 0.7">
                                 {{ "Pending " + getRevieweeLabel(true) + " submission" }}
                              </span>
                              <span
                                 *ngIf="isDVMSubmitted"
                                 style="font-weight: 700; color: #ffffff">
                                 <br />
                                 {{ "Submitted by Admin on " + getRevieweeSubmittedDatetime() }}
                              </span>
                              <span *ngIf="!isDVMSubmitted">{{ "Pending " + getRevieweeLabel(true) + " submission" }}</span>
                           } @else {
                              {{
                                 isDVMSubmitted
                                    ? getRevieweeLabel(true) + " submitted on " + getRevieweeSubmittedDatetime()
                                    : "Pending " + getRevieweeLabel(true) + " submission"
                              }}
                           }
                        </div>
                        <div
                           *ngIf="isCOSSubmitted && isReviewer"
                           class="submitted-info"
                           style="margin-bottom: 5px">
                           {{ getReviewerLabel(true) }} submitted on {{ getReviewerSubmittedDatetime() }}
                        </div>
                        <div
                           *ngIf="!isCOSSubmitted && isReviewer"
                           class="submitted-info"
                           style="margin-bottom: 5px; font-weight: 600; color: #f7f9fa; font-size: 17px">
                           Pending {{ getReviewerLabel(true) }} submission
                        </div>
                     </div>

                     <button
                        *ngIf="isDVMSubmitted && !isReviewer"
                        class="v-button v-button-lg v-teal disabled">
                        <i class="fa fa-check-circle"></i>
                        &nbsp;{{ getRevieweeLabel(true) }} Review submitted
                     </button>

                     <!-- Completed state -->
                     @if (userReview.isCompleted) {
                        <div
                           class="submitted-info"
                           *ngIf="isReviewer"
                           style="margin-bottom: 0px; margin-top: -20px">
                           Completed on &nbsp;{{ getCompletedDatetime() }}
                        </div>
                        <div
                           class="submitted-info"
                           style="margin-bottom: 10px; margin-top: -3px; color: #ffffff">
                           <span style="vertical-align: text-bottom">
                              <i
                                 class="fa fa-user-friends"
                                 style="font-size: 11px; margin-right: 3px"></i>
                           </span>
                           Final Review submitted by &nbsp;{{ submittedUserName }}
                        </div>

                        <button
                           *ngIf="isReviewer"
                           class="v-button v-button-lg v-teal disabled">
                           <i class="fa fa-check-circle"></i>
                           &nbsp;Review Completed
                        </button>
                     } @else if (canShowFinalFeedbackSection() && isReviewer) {
                        <button
                           (click)="onClickSave(true, false)"
                           class="v-button v-button-lg v-white"
                           [disabled]="isSubmittingUpdate || isFormReadOnly() || !isReviewTypeEnabled">
                           <i class="fa fa-arrow-up-from-bracket"></i>
                           &nbsp;Save Changes
                        </button>

                        <button
                           (click)="onClickSave(true, true)"
                           [disabled]="
                              isSubmittingUpdate ||
                              !finalFeedback ||
                              finalFeedback.trim().length === 0 ||
                              isFollowUpIncomplete() ||
                              isFormReadOnly() ||
                              !isReviewTypeEnabled
                           "
                           class="v-button v-button-lg v-teal">
                           <i class="fa fa-check-circle"></i>
                           &nbsp;{{ getSubmitButtonText() }}
                        </button>

                        <!-- Normal editing state -->
                     } @else if (shouldShowReviewerQuestions() || shouldShowRevieweeQuestions()) {
                        <button
                           *ngIf="!isFormSubmitted()"
                           (click)="onClickSave(false, false)"
                           [disabled]="(isDVMSubmitted && isCOSSubmitted) || isFormReadOnly() || !isReviewTypeEnabled"
                           class="v-button v-button-lg v-white">
                           <i class="fa fa-file-text-o"></i>
                           &nbsp;Save as Draft
                        </button>
                        <button
                           (click)="onClickSave(true, false)"
                           class="v-button v-button-lg v-white"
                           [disabled]="isSubmittingUpdate || isFormReadOnly() || !isReviewTypeEnabled"
                           *ngIf="canRevieweeEdit() && isDVMSubmitted">
                           <i class="fa fa-arrow-up-from-bracket"></i>
                           &nbsp;Save Changes
                        </button>
                        <button
                           *ngIf="!isFormSubmitted()"
                           [disabled]="isSubmittingUpdate || isFormReadOnly() || !isReviewTypeEnabled"
                           (click)="getSubmitButtonText() == 'Save Changes' ? onClickSave(true, false) : onClickSave(true, false)"
                           class="v-button v-button-lg v-teal">
                           <i class="fa fa-cloud-upload"></i>
                           &nbsp;{{ getSubmitButtonText() }}
                        </button>
                     }
                     <div
                        *ngIf="!userReview.isCompleted"
                        class="continueEditing">
                        Updates can be made until BOTH sides have submitted AND the review is finalized
                     </div>
                  </div>
               </div>
            </div>
         </vc-rounded-card>
      </div>

      <!-- Peer Input: ask a colleague to fill out a blank copy, then copy their answers in -->
      <peer-input-panel
         *ngIf="canRequestPeerInput()"
         [revieweeUserId]="peerRevieweeUserId"
         [reviewType]="reviewType"
         [reviewId]="userReview.id"
         [practiceSKey]="userReview.practiceSKey"
         [practiceName]="userReview.practiceName"
         [revieweeName]="userReview.revieweeName"
         [template]="getReviewTemplate()"
         [userReview]="userReview"
         (copyAnswers)="applyPeerAnswers($event)"></peer-input-panel>

      @if (shouldShowReviewerQuestions() || shouldShowRevieweeQuestions()) {
         <div
            class="grid-container profile-info"
            *ngIf="reviewType == 'DVM' && !isReviewer">
            <vc-rounded-card
               style="flex: 0.63"
               class="communications-container left">
               <!-- Communication Preferences - Different layouts for aDVM vs the others -->
               <div
                  *ngIf="isForDVM"
                  class="item-group">
                  <div
                     class="vc-field"
                     id="communicationPreference"
                     [class.has-error]="profileValidationErrors.has('profile:communicationPreference')">
                     <label class="vc-label">
                        Communication Preference
                        <span class="required-asterisk">*</span>
                     </label>

                     <div
                        class="d-flex flex-row vc-inline"
                        style="gap: 20px">
                        <vc-checkbox
                           inputId="comm-email"
                           label="Email"
                           [required]="true"
                           [ngModel]="selectedCommunicationPreferences.includes('0')"
                           (ngModelChange)="onCommunicationCheckboxChange('0', $event)"></vc-checkbox>

                        <vc-checkbox
                           inputId="comm-text"
                           label="Text"
                           [required]="true"
                           [ngModel]="selectedCommunicationPreferences.includes('1')"
                           (ngModelChange)="onCommunicationCheckboxChange('1', $event)"></vc-checkbox>

                        <vc-checkbox
                           inputId="comm-phone"
                           label="Phone Call"
                           [required]="true"
                           [ngModel]="selectedCommunicationPreferences.includes('2')"
                           (ngModelChange)="onCommunicationCheckboxChange('2', $event)"></vc-checkbox>
                     </div>
                  </div>
               </div>

               <!-- others Layout -->
               <div
                  *ngIf="!isForDVM"
                  class="row-container">
                  <div
                     class="item-group"
                     style="flex: 0.6; margin-right: 35px">
                     <div class="row-container con-info">
                        <div
                           class="vc-field"
                           id="communicationPreference"
                           [class.has-error]="profileValidationErrors.has('profile:communicationPreference')">
                           <label class="vc-label">
                              Communication Preference
                              <span class="required-asterisk">*</span>
                           </label>
                           <div
                              class="d-flex flex-row vc-inline"
                              style="gap: 20px">
                              <vc-checkbox
                                 inputId="comm-email"
                                 label="Email"
                                 [required]="true"
                                 [ngModel]="selectedCommunicationPreferences.includes('0')"
                                 (ngModelChange)="onCommunicationCheckboxChange('0', $event)"></vc-checkbox>

                              <vc-checkbox
                                 inputId="comm-text"
                                 label="Text"
                                 [required]="true"
                                 [ngModel]="selectedCommunicationPreferences.includes('1')"
                                 (ngModelChange)="onCommunicationCheckboxChange('1', $event)"></vc-checkbox>

                              <vc-checkbox
                                 inputId="comm-phone"
                                 label="Phone Call"
                                 [required]="true"
                                 [ngModel]="selectedCommunicationPreferences.includes('2')"
                                 (ngModelChange)="onCommunicationCheckboxChange('2', $event)"></vc-checkbox>
                           </div>
                        </div>
                     </div>

                     <div class="row-container con-info">
                        <div
                           class="item-group"
                           [class.has-error]="profileValidationErrors.has('profile:email') || profileValidationErrors.has('profile:emailFormat')">
                           <vc-text-input
                              label="Email"
                              id="emailInput"
                              type="email"
                              [required]="true"
                              [(ngModel)]="emailInputValue"
                              placeholder="Enter email"
                              [maxlength]="255"></vc-text-input>
                        </div>
                     </div>

                     <div class="row-container con-info">
                        <div
                           class="item-group"
                           style="flex: 0.6"
                           [class.has-error]="profileValidationErrors.has('profile:phone') || profileValidationErrors.has('profile:phoneFormat')">
                           <vc-text-input
                              label="Phone Number"
                              id="phoneInput"
                              type="tel"
                              [required]="true"
                              [(ngModel)]="phoneNumberInputValue"
                              placeholder="111-222-3333"
                              [maxlength]="12"
                              inputmode="numeric"></vc-text-input>
                        </div>
                        <div
                           class="item-group"
                           style="flex: 0.4"
                           [class.has-error]="profileValidationErrors.has('profile:gradYear')">
                           <vc-text-input
                              label="Grad Year"
                              id="gradYearInput"
                              type="text"
                              [required]="true"
                              [(ngModel)]="gradYearInputValue"
                              placeholder="e.g. 2026"
                              [maxlength]="4"
                              inputmode="numeric"></vc-text-input>
                        </div>
                     </div>

                     <div class="row-container">
                        <div
                           class="item-group"
                           [class.has-error]="profileValidationErrors.has('profile:vetSchool')">
                           <vc-single-select-dropdown
                              [items]="educationOptions"
                              id="vetSchoolDropdown"
                              placeholder="Make A Selection"
                              optionLabel="name"
                              label="Vet School"
                              [required]="true"
                              [filter]="true"
                              [filterBy]="'name'"
                              variantClass=""
                              sizeClass="v-dropdown-full"
                              [setValue]="selectedUniversity"
                              (selectionChange)="handleUniversityChanged($event)"></vc-single-select-dropdown>
                        </div>
                     </div>
                  </div>

                  <!-- YoY Metrics - Only for others -->
                  <div
                     class="item-group yoy-metrics"
                     style="flex: 0.4"
                     [class.has-error]="profileValidationErrors.has('profile:lendAHand')">
                     <label class="vc-label">Financial Metrics YoY</label>

                     <div class="table-responsive yoyTable-container">
                        <table
                           *ngIf="!isLoadingYoY && YoYResults?.length"
                           class="yoyTable">
                           <thead>
                              <tr class="columnHeaders">
                                 <th></th>
                                 <th style="text-align: right">2024</th>
                                 <th style="text-align: right">2025</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 *ngFor="let variant of YoYResults; let i = index"
                                 [class.alternate]="i % 2 !== 0">
                                 <td>{{ variant.Metric }}</td>
                                 <td style="color: #831183; text-align: right">{{ variant.YoY2024 ? variant.YoY2024 + "%" : "-" }}</td>
                                 <td style="color: #0caca5; text-align: right">{{ variant.YoY2025 ? variant.YoY2025 + "%" : "-" }}</td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>

               <!-- Profile info - aDVM Layout only -->
               <div
                  *ngIf="isForDVM"
                  class="row-container">
                  <div
                     class="item-group"
                     style="flex: 0.7"
                     [class.has-error]="profileValidationErrors.has('profile:email') || profileValidationErrors.has('profile:emailFormat')">
                     <vc-text-input
                        label="Email"
                        id="emailInput"
                        type="email"
                        [required]="true"
                        [(ngModel)]="emailInputValue"
                        placeholder="Enter email"
                        [maxlength]="255"></vc-text-input>
                  </div>

                  <div
                     class="item-group"
                     style="flex: 0.3"
                     [class.has-error]="profileValidationErrors.has('profile:phone') || profileValidationErrors.has('profile:phoneFormat')">
                     <vc-text-input
                        label="Phone Number"
                        id="phoneInput"
                        type="tel"
                        [required]="true"
                        [(ngModel)]="phoneNumberInputValue"
                        placeholder="111-222-3333"
                        [maxlength]="12"
                        inputmode="numeric"></vc-text-input>
                  </div>
               </div>

               <div
                  *ngIf="isForDVM"
                  class="row-container">
                  <div
                     class="item-group"
                     style="flex: 0.7"
                     [class.has-error]="profileValidationErrors.has('profile:vetSchool')">
                     <vc-single-select-dropdown
                        [items]="educationOptions"
                        id="vetSchoolDropdown"
                        placeholder="Make A Selection"
                        optionLabel="name"
                        label="Vet School"
                        [required]="true"
                        [filter]="true"
                        [filterBy]="'name'"
                        variantClass=""
                        sizeClass="v-dropdown-full"
                        [setValue]="selectedUniversity"
                        (selectionChange)="handleUniversityChanged($event)"></vc-single-select-dropdown>
                  </div>

                  <div
                     class="item-group"
                     style="flex: 0.3"
                     [class.has-error]="profileValidationErrors.has('profile:gradYear')">
                     <vc-text-input
                        label="Grad Year"
                        id="gradYearInput"
                        type="text"
                        [required]="true"
                        [(ngModel)]="gradYearInputValue"
                        placeholder="e.g. 2026"
                        [maxlength]="4"
                        inputmode="numeric"></vc-text-input>
                  </div>
               </div>

               <div class="row-container">
                  <div
                     class="item-group"
                     style="flex: 0.6"
                     [class.has-error]="profileValidationErrors.has('profile:yearsExperience')">
                     <vc-radio-group
                        [(ngModel)]="selectedYearsExperience"
                        id="yearsExperienceRadio"
                        direction="row"
                        [required]="true"
                        [radiobutton]="true"
                        label="Years Experience"
                        [options]="[
                           { label: '0-2', value: '0' },
                           { label: '3-5', value: '1' },
                           { label: '6-10', value: '2' },
                           { label: '10+', value: '3' },
                        ]"></vc-radio-group>
                  </div>

                  <div
                     class="item-group"
                     [style.flex]="'0.4'"
                     [style.margin-top]="isForDVM ? '0' : '5px'"
                     [class.has-error]="profileValidationErrors.has('profile:lendAHand')">
                     <vc-radio-group
                        [(ngModel)]="selectedLendAHand"
                        id="lendAHandRadio"
                        direction="row"
                        [yesno]="true"
                        [required]="true"
                        label="Interested in Lend-A-Hand Program"
                        infoTooltip="Lend-a-Hand are shifts available at other local hospitals and are paid at time-and-a-half. Choosing 'Yes' does not obligate you to work but allows us to reach out with the opportunity when coverage is needed."
                        [options]="[
                           { label: 'Yes', value: true },
                           { label: 'No', value: false },
                        ]"></vc-radio-group>
                  </div>
               </div>

               <div class="row-container">
                  <div
                     class="item-group boardCert"
                     style="flex: 0.6"
                     [class.has-error]="
                        profileValidationErrors.has('profile:boardCertified') || profileValidationErrors.has('profile:boardCertificationName')
                     ">
                     <vc-radio-group
                        [(ngModel)]="isBoardCertified"
                        id="boardCertifiedRadio"
                        direction="row"
                        [required]="true"
                        [yesno]="true"
                        [isInline]="true"
                        label="Are You Board Certified?"
                        [options]="[
                           { label: 'Yes', value: true },
                           { label: 'No', value: false },
                        ]"></vc-radio-group>
                     <div class="boardCert-text">
                        <vc-text-input
                           type="text"
                           id="boardCertificationInput"
                           [(ngModel)]="boardCertificationName"
                           [disabled]="!isBoardCertified"
                           [required]="isBoardCertified ? true : false"
                           placeholder="Enter board certification name"
                           [maxlength]="100"></vc-text-input>
                     </div>
                  </div>

                  <div
                     class="item-group"
                     style="flex: 0.4"
                     [class.has-error]="profileValidationErrors.has('profile:leaderAspirations')">
                     <vc-radio-group
                        [(ngModel)]="selectedLeaderAspirations"
                        id="leaderAspirationsRadio"
                        direction="row"
                        [required]="true"
                        [yesno]="true"
                        [infoTooltip]="
                           'If you are interested in growing into a leadership role, we want to support you every step of the way. Associates with leadership aspirations may be invited to participate in development conversations, mentorship opportunities, skill-building programs, and future leadership pathways. These steps are designed to help you explore your interests, build confidence, and prepare for potential leadership roles within the hospital or broader organization. Contact your Chief of Staff Advisor, ' +
                           userReview.vetLeaderName +
                           ', for Other information.'
                        "
                        label="Aspirations to be a Leader"
                        [options]="[
                           { label: 'Yes', value: true },
                           { label: 'No', value: false },
                        ]"></vc-radio-group>
                  </div>
               </div>
            </vc-rounded-card>

            <div
               class="medical-interests-container right"
               style="flex: 0.37"
               [class.interests-larger-gap]="!isForDVM"
               [class.has-error]="profileValidationErrors.has('profile:medicalInterests')">
               <vc-rounded-card>
                  <div
                     class="medical-group"
                     id="medical-interests-card">
                     <vc-dvm-medical-interests
                        [title]="'Medical Interests'"
                        [idPrefix]="'chk-interest'"
                        [interests]="medicalInterestOptions"
                        [selectedInterests]="medicalInterests"
                        [otherSelectedInterests]="medicalExpertise"
                        (selectionChanged)="handleMedicalInterestsChanged($event)"></vc-dvm-medical-interests>
                  </div>
               </vc-rounded-card>
            </div>
         </div>
      }

      <!-- YoY Metrics -->
      <vc-rounded-card
         *ngIf="(reviewType == 'HM' || reviewType == 'COS') && !printerModalOpened"
         style="margin-bottom: 20px">
         <div
            class="medical-group info-item"
            style="width: 100%">
            <div
               class="card-header justify-content-between align-items-center bg-light"
               style="font-weight: 600; font-size: 17px">
               Financial Metrics YoY
               <span
                  class="v-graycolor"
                  style="font-size: 14px">
                  &nbsp;({{ userReview.practiceName }})
               </span>
            </div>

            <div class="yoy-metrics-wide">
               <div class="table-responsive yoyTable-container">
                  <table
                     *ngIf="!isLoadingYoY && YoYResults?.length"
                     class="yoyTable">
                     <thead>
                        <tr class="columnHeaders">
                           <th></th>
                           <th
                              *ngFor="let variant of YoYResults"
                              style="text-align: right">
                              {{ variant.Metric }}
                           </th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr>
                           <td>2024</td>
                           <td
                              *ngFor="let variant of YoYResults"
                              style="color: #831183; text-align: right">
                              {{ variant.YoY2024 ? variant.YoY2024 + "%" : "-" }}
                           </td>
                        </tr>
                        <tr class="alternate">
                           <td>2025</td>
                           <td
                              *ngFor="let variant of YoYResults"
                              style="color: #0caca5; text-align: right">
                              {{ variant.YoY2025 ? variant.YoY2025 + "%" : "-" }}
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </vc-rounded-card>

      <div
         [ngClass]="canShowMergedView() ? 'merged-view-layout' : 'not-merged-view'"
         [class]="reviewType == 'HM' ? 'longer-sections' : ''"
         [class.print-spacing]="printReviewee && printReviewer ? false : true"
         [class.print-reviewer]="printReviewer && !printReviewee ? true : false"
         *ngIf="reviewType != 'TEAM'">
         <!-- Reviewee Assessment Sections -->
         <div
            class="dvm-section-parent"
            [ngClass]="{ 'cannot-edit': !canRevieweeEdit() }">
            <div style="display: flex; align-items: baseline; gap: 15px; justify-content: space-between">
               <div class="section-label">
                  <h4>{{ getRevieweeLabel() }} Self-Assessment</h4>
               </div>
               <div
                  *ngIf="canShowMergedView() && isDVMSubmitted"
                  class="merged-view-indicator">
                  <span class="badge badge-success">{{ getRevieweeLabel(true) }} Self-Assessment Submitted</span>
               </div>
            </div>

            <review-assessment-sections
               #revieweeSections
               *ngIf="shouldShowRevieweeQuestions() && allSectionsLoaded"
               [userReview]="userReview"
               [template]="getReviewTemplate()"
               mode="reviewee"
               [reviewType]="reviewType"
               [canEditReviewee]="canRevieweeEdit()"
               [canEditReviewer]="canReviewerEdit()"
               [additionalResponsibilities]="additionalResponsibilities"
               [isPrimaryReviewee]="isPrimaryReviewee"
               (dataChanged)="onRevieweeDataChanged($event)"></review-assessment-sections>
         </div>

         <!-- Reviewer Assessment Sections -->
         <div
            class="cos-section-parent"
            [ngClass]="{ 'cannot-edit': !canReviewerEdit() }">
            <div style="display: flex; align-items: baseline; gap: 15px; justify-content: space-between">
               <div class="section-label">
                  <h4>{{ getReviewerLabel() }} Review</h4>
               </div>
               <div
                  *ngIf="canShowMergedView() && isCOSSubmitted"
                  class="merged-view-indicator">
                  <span class="badge badge-success">{{ getReviewerLabel(true) }} Review Submitted</span>
               </div>
            </div>
            <review-assessment-sections
               #reviewerSections
               *ngIf="shouldShowReviewerQuestions() && allSectionsLoaded"
               [userReview]="userReview"
               [template]="getReviewTemplate()"
               mode="reviewer"
               [reviewType]="reviewType"
               [canEditReviewee]="canRevieweeEdit()"
               [canEditReviewer]="canReviewerEdit()"
               [additionalResponsibilities]="additionalResponsibilities"
               [includeCareerExploration]="includeCareerExploration"
               (includeCareerExplorationChanged)="includeCareerExploration = $event"
               [isPrimaryReviewee]="isPrimaryReviewee"
               (dataChanged)="onReviewerDataChanged($event)"></review-assessment-sections>
         </div>
         <div
            class="review-section grid-container"
            *ngIf="!shouldShowRevieweeQuestions() && !shouldShowReviewerQuestions() && isUnderReview">
            <vc-rounded-card style="flex: 1">
               <div class="text-center p-4">
                  <h3 class="mb-4">Review In Progress</h3>
                  <p
                     class="mb-3"
                     style="font-size: 16px">
                     This review is currently in progress. You will be able to view the completed assessments once both the
                     <strong>{{ getRevieweeLabel() }}</strong>
                     and
                     <strong>{{ getReviewerLabel() }}</strong>
                     have submitted their portions.
                  </p>

                  <div
                     style="background: #f8f9fa"
                     class="p-4 mt-5">
                     <p class="mb-3"><strong>Current Status:</strong></p>
                     <div style="display: flex; gap: 35px; justify-content: center">
                        <div>
                           <i
                              class="fa {{ isDVMSubmitted ? 'fa-check-circle' : 'fa-clock' }}"
                              [style.color]="isDVMSubmitted ? '#02bd85' : '#6c757d'"></i>
                           &nbsp;{{ getRevieweeLabel() }}: {{ isDVMSubmitted ? "Submitted" : "Pending" }}
                        </div>
                        <div>
                           <i
                              class="fa {{ isCOSSubmitted ? 'fa-check-circle' : 'fa-clock' }}"
                              [style.color]="isCOSSubmitted ? '#02bd85' : '#6c757d'"></i>
                           &nbsp;{{ getReviewerLabel() }}: {{ isCOSSubmitted ? "Submitted" : "Pending" }}
                        </div>
                     </div>
                  </div>
               </div>
            </vc-rounded-card>
         </div>
      </div>

      <!-- FINAL FEEDBACK SECTION - Only shows when both DVM and COS submit -->
      <div
         *ngIf="canShowFinalFeedbackSection()"
         class="grid-container final-feedback-section"
         id="final-feedback-section">
         <vc-rounded-card style="flex: 1">
            <div
               class="card-header d-flex justify-content-between align-items-center"
               style="border-top-left-radius: 8px; border-top-right-radius: 8px; margin-top: -25px; margin-right: -30px; margin-left: -30px">
               <span class="overall-comments-header">
                  <h3>
                     <i class="fa fa-comments"></i>
                     &nbsp;Final Collaborative Feedback
                  </h3>
               </span>
            </div>

            <div class="alert alert-info">
               <p class="mb-0">
                  <strong>Both the {{ getRevieweeLabel() }} and {{ getReviewerLabel() }} have submitted their reviews.</strong>
               </p>
            </div>

            <div class="item-group-assessment mt-0">
               <vc-textarea
                  label="Final Feedback & Action Items"
                  [(ngModel)]="finalFeedback"
                  [required]="true"
                  [maxlength]="2000"
                  rows="8"
                  [disabled]="userReview?.isCompleted"
                  placeholder="Summarize key takeaways, agreed-upon goals, and next steps from this performance review..."></vc-textarea>
               <!--<div class="feedbackSub">
                  Please note: this information is not available to the {{ getRevieweeLabel() }} even after you complete & finalize this review
               </div>-->

               <!-- Follow up section -->
               <div
                  class="follow-up-section mt-3"
                  style="display: none">
                  <vc-checkbox
                     label="Follow up required"
                     [(ngModel)]="followUpRequired"
                     [disabled]="userReview?.isCompleted"></vc-checkbox>

                  <div
                     *ngIf="followUpRequired"
                     class="follow-up-details mt-3">
                     <!-- Notes -->
                     <vc-textarea
                        label="What follow up is needed?"
                        [(ngModel)]="followUpNotes"
                        [required]="true"
                        [maxlength]="1000"
                        rows="3"
                        [disabled]="userReview?.isCompleted"
                        placeholder="Describe the follow up required..."></vc-textarea>

                     <!-- Follow up by -->
                     <vc-radio-group
                        id="followUpByRadio"
                        direction="row"
                        [radiobutton]="true"
                        label="Follow up by"
                        [required]="true"
                        [disabled]="userReview?.isCompleted"
                        [(ngModel)]="followUpBy"
                        [options]="[
                           { label: 'RM', value: 'RM' },
                           { label: 'COS', value: 'COS' },
                           { label: 'COSA', value: 'COSA' },
                           { label: 'Other', value: 'Other' },
                        ]"></vc-radio-group>

                     <vc-text-input
                        *ngIf="followUpBy === 'Other'"
                        label="Specify who should follow up"
                        id="followUpByOtherInput"
                        type="text"
                        [required]="true"
                        [disabled]="userReview?.isCompleted"
                        [(ngModel)]="followUpByOther"
                        placeholder="Enter name or role..."
                        [maxlength]="200"></vc-text-input>

                     <!-- Timeframe -->
                     <vc-radio-group
                        id="followUpTimeframeRadio"
                        direction="row"
                        [radiobutton]="true"
                        label="Follow up timeframe"
                        [required]="true"
                        [disabled]="userReview?.isCompleted"
                        [(ngModel)]="followUpTimeframe"
                        [options]="[
                           { label: '2 weeks', value: '2 weeks' },
                           { label: '1 month', value: '1 month' },
                           { label: '1 quarter', value: '1 quarter' },
                           { label: '6 months', value: '6 months' },
                           { label: 'Open', value: 'Open' },
                        ]"></vc-radio-group>

                     <vc-text-input
                        *ngIf="followUpTimeframe === 'Open'"
                        label="Specify timeframe"
                        id="followUpTimeframeOpenInput"
                        type="text"
                        [required]="true"
                        [disabled]="userReview?.isCompleted"
                        [(ngModel)]="followUpTimeframeOpen"
                        placeholder="Enter timeframe..."
                        [maxlength]="200"></vc-text-input>
                  </div>

                  <!-- Read-only summary when completed -->
                  <div
                     *ngIf="userReview?.isCompleted && followUpRequired"
                     class="follow-up-summary mt-2">
                     <div *ngIf="followUpNotes">
                        <strong>Follow up needed:</strong>
                        {{ followUpNotes }}
                     </div>
                     <div *ngIf="followUpBy">
                        <strong>Follow up by:</strong>
                        {{ followUpBy === "Other" ? followUpByOther : followUpBy }}
                     </div>
                     <div *ngIf="followUpTimeframe">
                        <strong>Timeframe:</strong>
                        {{ followUpTimeframe === "Open" ? followUpTimeframeOpen : followUpTimeframe }}
                     </div>
                  </div>
               </div>
            </div>

            <div
               *ngIf="!userReview?.isCompleted"
               class="mt-1 mb-3 text-center">
               <button
                  class="v-button v-button-lg v-darkgreen"
                  (click)="onClickSave(false, true)"
                  [disabled]="
                     !finalFeedback ||
                     finalFeedback.trim().length === 0 ||
                     isFollowUpIncomplete() ||
                     isFormReadOnly() ||
                     isSubmittingUpdate ||
                     !isReviewTypeEnabled
                  ">
                  <i class="fa fa-check-circle"></i>
                  Complete & Finalize Review
               </button>
            </div>

            <div
               *ngIf="userReview?.isCompleted"
               class="completion-notice mt-1 mb-3">
               <div>
                  <i class="fa fa-check-circle"></i>
                  <strong>Review Completed</strong>
                  on {{ getCompletedDatetime() }}
               </div>
            </div>
         </vc-rounded-card>
      </div>

      <div class="mb-2">&nbsp;</div>

      <div style="display: flex; flex-direction: row; gap: 15px; margin-top: 0px; justify-content: center">
         @if (userReview.isCompleted) {
         } @else if (canShowFinalFeedbackSection()) {
         } @else if (shouldShowReviewerQuestions() || shouldShowRevieweeQuestions()) {
            <button
               *ngIf="!isFormSubmitted() && !isDVMSubmitted && !isCOSSubmitted"
               (click)="onClickSave(false, false)"
               class="v-button v-button-lg v-white"
               [disabled]="isFormReadOnly() || !isReviewTypeEnabled">
               <i class="fa fa-file-text-o"></i>
               &nbsp;Save as Draft
            </button>
            <button
               *ngIf="!isFormSubmitted()"
               (click)="onClickSave(true, false)"
               [disabled]="isFormReadOnly() || isSubmittingUpdate || !isReviewTypeEnabled"
               class="v-button v-button-lg v-teal">
               <i class="fa fa-cloud-upload"></i>
               &nbsp;{{ getSubmitButtonText() }}
            </button>
         }
      </div>

      <div
         class="autosave-toast"
         [class.show]="showAutosaveToast">
         <i class="fa fa-check-circle"></i>
         <span>Your changes have been saved</span>
      </div>

      <!-- Back to Top Button -->
      <button
         *ngIf="showBackToTop"
         class="back-to-top-button"
         (click)="scrollToTop()"
         aria-label="Back to top">
         <i class="fa fa-chevron-up"></i>
      </button>
   </div>
</div>

<!-- Export column-picker modal -->
<div class="print-modal">
   <ng-container *ngIf="printChoiceDialog().show">
      <div
         class="export-overlay"
         (click)="closePrintChoiceModal()"></div>

      <div class="export-modal">
         <div class="export-modal__header">
            <div class="export-modal__icon">
               <i class="fa fa-print"></i>
            </div>
            <div class="export-modal__titles">
               <div class="export-modal__title">Which reviews do you want to print?</div>
               <div class="export-modal__subtitle">Self-Assessment, Performance Review, or Merged View</div>
            </div>
            <button
               type="button"
               class="export-modal__close"
               title="Close"
               (click)="closePrintChoiceModal()">
               <i class="fa fa-xmark"></i>
            </button>
         </div>

         <div class="export-modal__lang">
            <span class="export-modal__lang-label">Print language</span>
            <div class="lang-segment">
               <button
                  type="button"
                  [class.active]="!printInSpanish"
                  [disabled]="isTranslating"
                  (click)="printInSpanish = false">
                  English
               </button>
               <button
                  type="button"
                  [class.active]="printInSpanish"
                  [disabled]="isTranslating"
                  (click)="printInSpanish = true">
                  Español
               </button>
            </div>
         </div>
         <div
            *ngIf="isTranslating"
            class="export-modal__translating">
            <i class="fa fa-spinner fa-spin"></i>
            &nbsp;Translating to Spanish…
         </div>

         <div class="export-modal__grid">
            <label
               class="export-col"
               (click)="printReviewee = true; printReviewer = false; printReview()"
               [class.export-col--selected]="false">
               <span class="export-col__icon">
                  <i class="fa fa-print"></i>
               </span>
               <span class="export-col__label">Self-Assessment Only</span>
            </label>

            <label
               class="export-col"
               (click)="printReviewee = false; printReviewer = true; printReview()"
               [class.export-col--selected]="false">
               <span class="export-col__icon">
                  <i class="fa fa-print"></i>
               </span>
               <span class="export-col__label">Performance Review Only</span>
            </label>

            <label
               class="export-col"
               (click)="printReviewee = true; printReviewer = true; printReview()"
               [class.export-col--selected]="false">
               <span class="export-col__icon">
                  <i class="fa fa-print"></i>
               </span>
               <span class="export-col__label">Merged View</span>
            </label>
         </div>
      </div>
   </ng-container>
</div>
